<template>
  <el-dialog :title="selRow.id == undefined ? '新增视频信息' : '编辑视频信息'"
             :visible.sync="visible"
             width="75%"
             :append-to-body="true"
             @open="handleOpen"
             @before-close="handleClose">
    <el-row>
      <el-form :model="form" ref="form" label-width="125px" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="课程名称" prop="lessonId">
              <el-select v-model="form.lessonId" clearable placeholder="请选择课程名称" style="width: 100%" size="medium">
                <el-option v-for="item in lessonBaseList" :key="item.id" :label="item.lessonName"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="视频名称" prop="videoName" style="margin-bottom: 11px;">
              <el-input v-model="form.videoName" placeholder='请输入视频名称' size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="播放时长" prop="videoLength" style="margin-bottom: 11px;">
              <el-input v-model="form.videoLength" placeholder='请输入播放时长' size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序号" prop="orderNo" style="margin-bottom: 11px;">
              <el-input v-model="form.orderNo" placeholder='请输入排序号' size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="上传附件" prop="attachList">
              <el-upload action="/sysAttach/uploadTempAttach/VIDEO"
                         list-type="text" :accept="attachAcceptType"
                         :on-error="attachHandleError" :on-success="attachHandleSuccess"
                         :on-remove="attachHandleRemove" :on-preview="attachHandlePreview"
                         :before-upload="attachBeforeUpload" :before-remove="attachBeforeRemove"
                         :on-exceed="attachHandleExceedOne" :file-list="attachList" :limit="1"
                         :show-file-list=true multiple style="width: 400px">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red"> 上传文件大小不超过500MB，最多上传1个附件</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上传课件" prop="attachFileList">
              <el-upload action="/sysAttach/uploadTempAttach/LESSON_COURSEWARE"
                         list-type="text" :accept="attachFileAcceptType"
                         :on-error="attachFileHandleError" :on-success="attachFileHandleSuccess"
                         :on-remove="attachFileHandleRemove" :on-preview="attachFileHandlePreview"
                         :before-upload="attachFileBeforeUpload" :before-remove="attachFileBeforeRemove"
                         :on-exceed="attachFileHandleExceedOne" :file-list="attachFileList" :limit="1"
                         :show-file-list=true multiple style="width: 400px">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red"> 上传文件大小不超过10MB，最多上传1个附件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="float: right; right: -10px;padding-bottom: 10px;">
        <el-button type="primary" @click="submit" size="medium">确定</el-button>
        <el-button @click="handleClose" size="medium">取消</el-button>
      </div>
    </el-row>
  </el-dialog>
</template>

<script>
import {addLessonVideo, updateLessonVideo } from "@/api/core/lessonVideo";
import {commonAttachMixin} from "../../../../utils/commonAttachMixin";

export default {
  name: "LessonVideoForm",
  mixins: [commonAttachMixin],
  props:['selRow','lessonBaseList'],
  data() {
    return {
      form : {
        lessonType:0
      },
      attachList:[],
      attachFileList:[],
      workTypeList:[],
      hospitalList:[],
      visible: false,
      attachFileAcceptType: '.xls,.xlsx,.doc,.docx,.pdf,.pptx,.ppt',
      attachAcceptType: '.mp4,.wav',
      rules:{
        lessonId:[
          {required: true, message: '请选择课程名称',trigger:'change'}
        ],
        videoName:[
          {required: true, message: '请输入视频名称',trigger:'change'}
        ],
        videoLength:[
          {required: true, message: '请输入播放时长',trigger:'change'}
        ],
        orderNo:[
          {required: true, message: '请输入排序号',trigger:'change'}
        ]
      }
    }
  },
  watch: {
    attachFileList(n) {
      this.form.attachFileIds = n.map(attach => attach.id);
      console.log(this.form.attachFileIds)
    }
  },
  methods:{
    async handleOpen() {
      console.log("lessonBaseList",this.lessonBaseList)
      this.attachList = [];
      this.attachFileList = []
      this.form = {...this.selRow};
      if(this.form.lessonType != undefined){
        this.form.lessonType = this.form.lessonType.toString();
      }
      if (this.form.id) {
        this.attachList = await this.findAttachListByDataId(this.form.id, 'VIDEO')
      }
      if (this.form.id) {
        this.attachFileList = await this.findAttachListByDataId(this.form.id, 'LESSON_COURSEWARE')
      }
    },
    handleClose() {
      this.attachList = []
      this.form = {}
      this.visible = false
      this.$emit('refreshList');
    },
    async submit() {
      if(this.attachList.length === 0){
        this.$message.error(`附件不可为空，请重新上传后提交表单`)
        return
      }
   /*   if(this.attachFileList.length === 0){
        this.$message.error(`附件不可为空，请重新上传后提交表单`)
        return
      }*/
      let that = this
      let is_add = that.form.id ? true: false
      that.$refs.form.validate().then(()=>{
        if (is_add){
          return updateLessonVideo(that.form)
        }
        return addLessonVideo(that.form)
      }).then(res => {
        that.handleClose()
        if (res.success) {
          if (is_add){
            that.$message({
              type: "success",
              message: '编辑成功'
            });
          }else {
            that.$message({
              type: "success",
              message: '添加成功'
            });
          }
          that.$emit('refreshList')
        }
      }).catch(() => {
      })
    },


    attachFileHandleError(err, file) {
      this.$message.error(`${file.name} 附件上传发生错误：${err}，请重新上传`)
    },
    attachFileHandleSuccess(resp, file, fileList) {
      if (resp.status !== 200) {
        let err = '未知错误';
        if (resp.msg) err = resp.msg;
        this.$message.error(`${file.name} 附件上传发生异常：${err}，请手动删掉已上传的附件并重新上传`);
        return
      }
      if (resp.obj && resp.obj.id) {
        file.id = resp.obj.id;
        this.attachFileList = fileList;
      }
    },
    attachFileHandleRemove(file, fileList) {
      this.attachFileList = fileList;
    },
    attachFileHandlePreview(file) {
      window.open(`/sysAttach/downLoadAttach?attachId=${file.id}`)
    },
    attachFileBeforeUpload(file) {
      let fileSuffix = file.name.substring(file.name.lastIndexOf("."), file.name.length);
      if (this.attachFileAcceptType.indexOf(fileSuffix) === -1) {
        this.$message.warning(`不支持${fileSuffix}类型的附件`);
        return false
      }
    },
    attachFileBeforeRemove(file) {
      if (file.status !== 'success') return;
      return this.$confirm(`确定移除 ${file.name}？`, '提示', {type: 'warning'}).then(_ => {
        if (file.id && file.state && file.state === 1) {
          this.postRequest('/sysAttach/delete', {'attachId': file.id});
        }
      })
    },
    attachFileHandleExceedOne(files, fileList) {
      this.$message.warning(`只能上传1个附件`)
    },
    attachHandleExceedOne(files, fileList) {
      this.$message.warning(`只能上传1个附件`)
    },
  }
}
</script>

<style scoped>

</style>